// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
@media (max-width: 768px) {
  .app-container {
    flex-direction: column;
  }

  .left-panel, .right-panel {
    width: 100% !important;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}
.app-container {
  display: flex;
  transition: all 0.3s ease-in-out;
}

.left-panel, .right-panel {
  transition: all 0.3s ease-in-out;
}

.left-panel {
  width: 50%;
  background-color: #f97316;
  padding: 48px;
}

.right-panel {
  width: 50%;
  background-color: white;
  padding: 48px;
}

.app-container.expanded .left-panel {
  width: 33.33%;
}

.app-container.expanded .right-panel {
  width: 66.67%;
}

.left-panel > *, .right-panel > * {
  transition: all 0.5s ease-in-out;
}

.app-container.expanded .left-panel > * {
  transform: scale(0.8);
}

.app-container.expanded .right-panel > * {
  transform: scale(1.2);
}

/* Add any additional styling as needed */

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;AACA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yCAAyC;;AAEzC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n@media (max-width: 768px) {\n  .app-container {\n    flex-direction: column;\n  }\n\n  .left-panel, .right-panel {\n    width: 100% !important;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n.app-container {\n  display: flex;\n  transition: all 0.3s ease-in-out;\n}\n\n.left-panel, .right-panel {\n  transition: all 0.3s ease-in-out;\n}\n\n.left-panel {\n  width: 50%;\n  background-color: #f97316;\n  padding: 48px;\n}\n\n.right-panel {\n  width: 50%;\n  background-color: white;\n  padding: 48px;\n}\n\n.app-container.expanded .left-panel {\n  width: 33.33%;\n}\n\n.app-container.expanded .right-panel {\n  width: 66.67%;\n}\n\n.left-panel > *, .right-panel > * {\n  transition: all 0.5s ease-in-out;\n}\n\n.app-container.expanded .left-panel > * {\n  transform: scale(0.8);\n}\n\n.app-container.expanded .right-panel > * {\n  transform: scale(1.2);\n}\n\n/* Add any additional styling as needed */\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
